module.exports = __webpack_public_path__ + "static/media/rent.c50d811b.svg";